import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { PercentageDisplay } from "commonComponents/financial/PercentageDisplay/PercentageDisplay";
import { type IFooterCellProps } from "commonComponents/utilities/Grid/common/BTGridFooterCell/BTGridFooterCell";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

interface IPercentageResponse {
    value: number | undefined;
    scale: number;
}

interface IPercentageFooterCellProps extends IFooterCellProps {}

const renderPercentageCell = (value: number | undefined, scale?: number) => {
    if (value === undefined || value === null) return null;

    return <PercentageDisplay value={value} decimalScale={scale} data-testid="percentageCell" />;
};
class PercentageCell extends PureComponent<IGridCellRenderProps<IPercentageResponse | undefined>> {
    render() {
        const { cellValue } = this.props;
        return cellValue ? renderPercentageCell(cellValue.value, cellValue.scale) : null;
    }
}

export class PercentageFooterCell extends PureComponent<IPercentageFooterCellProps> {
    render() {
        const { value } = this.props;
        if (!value || value.value === undefined || value.value === null) {
            return null;
        }
        return (
            <PercentageDisplay
                value={value.value}
                decimalScale={value.scale}
                data-testid="percentageFooter"
            />
        );
    }
}

export const columnPercentage: IClientGridColumn<IPercentageResponse | undefined> = {
    validationSchema: yup.object<IPercentageResponse>({
        value: yup.number(),
        scale: yup.number(),
    }),
    columnType: GridColumnType.percentage,
    Cell: PercentageCell,
    FooterCell: PercentageFooterCell,
};
